import { pageResolver } from '@/core/component-resolver.service';
import { defineAsyncComponent } from 'vue';

const asyncB2BContentPage = defineAsyncComponent(() => import(/* webpackPrefetch: true */ './B2BContentPage.vue'));

// Content pages
pageResolver.register('B2BContentPageViewModel', asyncB2BContentPage);
